<template>
  <v-app>
    <v-main>
      <v-container fluid class="pr-lg-8 pl-lg-8">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import '@/assets/scss/theme.scss'
import '@/assets/scss/animations.scss'
import '@/assets/scss/generic.scss'
import '@/assets/scss/overrides.scss'

export default {
  name: 'Auth',
}
</script>
